import React, { useEffect,useState } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Container, Row, Col } from 'react-bootstrap';
import { FaPaperPlane } from "react-icons/fa";
import contactbanner from '../Assets/food/contactUsBack.png';
import '../Assets/WebsiteCss/contact.css';
import { BsTelephoneFill, BsEnvelopeFill, BsGeoAltFill } from 'react-icons/bs'
import { Helmet } from "react-helmet";
import { FaPhoneAlt } from 'react-icons/fa';
import { FaEnvelope } from 'react-icons/fa';
import axios from "axios";
import { BASE_URL } from '../BaseURL';
import { toast, Toaster } from "react-hot-toast";
import { Spinner } from "react-bootstrap";

export default function Contact() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [formData, setFormData] = useState({
    userName: "",
    email: "",
    mobile: "",
    companyName: "",
    city: "",
    interest: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email) {
      toast.error("Email is required.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/enquiry/sendContactEnquiry`, formData);
      toast.success("Enquiry sent successfully!");
      console.log(response.data);

      // Reset form
      setFormData({
        userName: "",
        email: "",
        mobile: "",
        companyName: "",
        city: "",
        interest: "",
        message: "",
      });
    } catch (error) {
      console.error("Error sending enquiry:", error);
      toast.error("Failed to send enquiry.");
    } finally {
      setLoading(false);
    }
  };

  
  return (
    <>
      <Toaster />
    <div className="mainnav min-vh-100">
   

      <Helmet>
        {/* Page Title */}
        <title>Contact Us | Karigar India Namkeen Labour Contractor</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Get in touch with Karigar India for skilled manpower and labour contracting solutions in Namkeen, Sweets, Snacks, and Bakery production. Contact us via phone or email for inquiries and support."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="Karigar India, Contact Us, Namkeen Karigar, Sweets Karigar, Snacks Karigar, Bakery Karigar, Labour Contractor, Skilled Manpower, Production Support, Packaging Staff"
        />

        {/* Author */}
        <meta name="author" content="Karigar India" />

        {/* Robots */}
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Contact Us | Karigar India Namkeen Labour Contractor" />
        <meta property="og:description" content="Reach out to Karigar India for skilled manpower, labour contracting, and production support for Namkeen, Sweets, Snacks, and Bakery units." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.karigarindia.in/contact" />
        <meta property="og:image" content="https://www.karigarindia.in/logo.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Us | Karigar India Namkeen Labour Contractor" />
        <meta name="twitter:description" content="Get in touch with Karigar India for skilled Karigars, supervisors, and packing staff. Contact us for labor contracting and production support." />
        <meta name="twitter:image" content="https://www.karigarindia.in/logo.png" />

        {/* Favicon */}
        <link rel="icon" href="/logo.png" />
      </Helmet>
      
        {/* Banner */}
        <div className="service-container">
          <img src={contactbanner} alt="" className="servicenamkken img-fluid" />
          <div className="service-overlay"></div>
          <div className="service-text">Get In Touch With Us, We're Here to Help!</div>
        </div>
       
   
        <Container className="py-3">
  <div className="mb-4 text-center">
    <h2 className="middletext mb-1" data-aos="zoom-in">Contact Us</h2>
    <p className="text-muted">Connect with the experts in namkeen production and labor contracting.</p>
  </div>

  <Row className="g-4 ">
   
<Row className="g-4">

 <Col md={6}>
  <div className="p-4 shadow rounded contact-info-box h-100 bg-light">
    <h4 className="mb-4 text-center text-primary fw-bold">
      <FaPhoneAlt className="me-2" />
      Get in Touch
    </h4>
    <p>
      <BsTelephoneFill color="#23326a" className="me-2 fs-5" />
      +91 9257781777
    </p>
    <p>
      <BsEnvelopeFill color="#DC4321" className="me-2 fs-5" />
      info@karigarindia.in
    </p>
    <p>
      <BsGeoAltFill className="me-2 text-success fs-5" />
      Bhilwara, 311001, Rajasthan, India
    </p>

    {/* Embedded Google Map below contact info */}
    <div className="mt-4 rounded overflow-hidden" style={{ height: "250px" }}>
  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48153.64790753855!2d74.59053621383384!3d25.34149239378299!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3968c2368c070a55%3A0xc92f70a42dcb5294!2sBhilwara%2C%20Rajasthan!5e1!3m2!1sen!2sin!4v1766210945357!5m2!1sen!2sin" 
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>

  </div>
</Col>
    <Col md={6}>
  <div className="p-4 shadow rounded bg-white h-100">
  <form onSubmit={handleSubmit} >
<h4 className="mb-4 text-center text-primary fw-bold">
  <FaEnvelope className="me-2" />
  Send a Message
</h4>
      <Row>
        <Col md={6} className="mb-3">
          <div className="form-floating">
            <input
              type="text"
              name="userName"
              className="form-control"
              placeholder="Your Name"
              required
              value={formData.userName}
              onChange={handleChange}
            />
            <label>Your Name</label>
          </div>
        </Col>
        <Col md={6} className="mb-3">
          <div className="form-floating">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Email Address"
              required
              value={formData.email}
              onChange={handleChange}
            />
            <label>Email Address</label>
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="mb-3">
          <div className="form-floating">
            <input
              type="text"
              name="mobile"
              className="form-control"
              placeholder="Phone Number"
              required
              value={formData.mobile}
              onChange={handleChange}
              maxLength={10}
            />
            <label>Phone Number</label>
          </div>
        </Col>
        <Col md={6} className="mb-3">
        <div className=" form-floating">
        <input
          type="text"
          name="city"
          className="form-control"
          placeholder="City"
          value={formData.city}
          onChange={handleChange}
        />
        <label>City</label>
      </div>
        </Col>
      </Row>

      <div className="form-floating mb-3">
            <input
              type="text"
              name="companyName"
              className="form-control"
              placeholder="Company Name"
              value={formData.companyName}
              onChange={handleChange}
            />
            <label>Company Name</label>
          </div>

      <div className="mb-3 form-floating">
        <select
          className="form-select"
          name="interest"
          required
          value={formData.interest}
          onChange={handleChange}
        >
          <option value="">Select Your Interest</option>
          <option value="Namkeen Labour">Namkeen Labour</option>
          <option value="Want to know about team work">Want to know about team work</option>
          <option value="Namkeen Recipe">Namkeen Recipe</option>
          <option value="I'm in Namkeen Business & want to grow">I'm in Namkeen Business & want to grow</option>
          <option value="I want to upgrade product Quality">I want to upgrade product Quality</option>
        </select>
        <label>Select Your Interest</label>
      </div>

      <div className="mb-4 form-floating">
        <textarea
          className="form-control"
          name="message"
          placeholder="Your Message"
          style={{ height: "120px" }}
          required
          value={formData.message}
          onChange={handleChange}
        />
        <label>Your Message</label>
      </div>

      <div className="text-center">
        <button
          type="submit"
          className="btn btn-primary px-4 py-2 custom-btn
          text-white fw-bold shadow-sm d-inline-flex align-items-center"
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
              Sending...
            </>
          ) : (
            <>
              <FaPaperPlane className="me-2 " />
              Send Message
            </>
          )}
        </button>
      </div>
    </form>
  </div>
</Col>
</Row>
  </Row>
</Container> 
  
  </div>
    
    </>
  )
}
